import { Box, type BoxProps, type MantineNumberSize } from '@mantine/core'
import { compact, map } from 'lodash'
import { type CSSProperties, type FC } from 'react'

import { PropertyListItem } from './PropertyListItem'

export interface PropertyListProps extends Omit<BoxProps, 'children'> {
  // null items are dropped, so a caller can inline a conditional row without building the array first
  items: Array<{ label: string; value: any } | null>
  // defaults to sizing the label column to the widest label; pass a width to force a fixed column
  labelWidth?: CSSProperties['gridTemplateColumns']
  size?: MantineNumberSize
}

export const PropertyList: FC<PropertyListProps> = ({ items, labelWidth = 'max-content', size, ...props }) => (
  <Box
    sx={(theme) => ({
      alignItems: 'start',
      columnGap: theme.spacing.xs,
      display: 'grid',
      // `minmax(0, 1fr)` rather than `1fr` so a long value wraps inside the column instead of
      // overflowing it — 1fr's automatic minimum is min-content, which refuses to shrink
      gridTemplateColumns: `${labelWidth} minmax(0, 1fr)`,
      rowGap: theme.spacing.xs
    })}
    {...props}
  >
    {map(compact(items), (item, itemIdx) => (
      <PropertyListItem
        key={`item-${itemIdx}`}
        size={size}
        {...item}
      />
    ))}
  </Box>
)
